import script from "./adjustments-selective-copy.vue?vue&type=script&setup=true&lang=ts"
export * from "./adjustments-selective-copy.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__